import { render, staticRenderFns } from "./DocumentoAdjunto.vue?vue&type=template&id=2fdc83ed&scoped=true&"
import script from "./DocumentoAdjunto.vue?vue&type=script&lang=js&"
export * from "./DocumentoAdjunto.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoAdjunto.vue?vue&type=style&index=0&id=2fdc83ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc83ed",
  null
  
)

export default component.exports